
























import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import Avatar from '@/components/Avatar.vue';
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tooltip
} from 'element-ui';

import { operatorService } from '@/services/OperatorService';
import { OperatorFields } from '@/types/graphql/schemaTypes';

import fetchOperatorsQuery from '@/graphql/queries/FetchOperators.gql';

import get from 'lodash/get';

@Component({
  apollo: {
    operators: {
      query: fetchOperatorsQuery,
      prefetch: true,
      fetchPolicy: 'cache-and-network',
      update(data) {
        return data.operators;
      }
    }
  },
  components: {
    Avatar,
    'el-dropdown': Dropdown,
    'el-dropdown-menu': DropdownMenu,
    'el-dropdown-item': DropdownItem,
    'el-tooltip': Tooltip
  }
})
export default class AssignOperator extends Vue {
  @Prop({ required: true, type: null as any }) private assigned!: OperatorFields | null;
  @Prop({ required: true, type: String }) private shipmentId!: string;
  @Prop({ default: 'small', type: [String, Number] }) private size!: string | number;

  public operators: OperatorFields[] = [];

  private userAvatar(operator: OperatorFields): string {
    return get(operator, 'avatar.url') || '';
  }

  private updateShipmentOperator(operatorId: string | null) {
    if (operatorId) {
      operatorService.assignShipment(this.shipmentId, operatorId).then((res) => {
        this.$emit('refresh');
      });
    } else {
      operatorService.unassignShipment(this.shipmentId).then((res) => {
        this.$emit('refresh');
      });
    }
  }

  get filteredOperators() {
    return this.operators.filter((operator) => {
      if (!this.assigned || this.assigned.id !== operator.id) {
        return operator;
      }
    });
  }
}
